export const enum AgGridActionsEnum {
  Run = 1,
  Import = 2,
  SaveLayout = 3,
  ClearFilters = 4,
  ClearSort = 5,
  LoadData = 6,
  showColumn = 7,
  hideColumn = 8,
  selectedRow = 9,
  rowCount = 10,
  generateFile = 11,
  closeModal = 12,
  duplicateTrips = 13,
  SetReservationPlanTypeAndRegion = 14
}

export const AgGridTypeEventEnum =  {
  SelectionChange: 'selectionChanged',
  FilterChanged: 'filterChanged'
};



// WEBPACK FOOTER //
// ./src/app/core/enums/ag-grid-actions.enums.ts